module.exports = __webpack_public_path__ + "static/media/python.92d3d25a.png";